import { EditOutlined } from "@ant-design/icons";
import { Table, Row, Col, Button } from "antd";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";

import { SportPartnersTableState } from "./table.state";

type Props = {
  state: SportPartnersTableState;
};

export const SportPartnersTableView = observer<Props>(({ state }) => {
  return (
    <Table
      loading={state.query.isPending}
      bordered
      dataSource={state.query.items}
      columns={[
        {
          key: "id",
          dataIndex: "id",
          title: "ID",
        },
        {
          key: "currency",
          dataIndex: "currency",
          title: "Currency",
        },
        {
          key: "description",
          dataIndex: "description",
          width: "100%",
          title: "Description",
        },
        {
          key: "actions",
          align: "right",
          title: "Actions",
          render: (_, partner) => {
            return (
              <Row gutter={[12, 12]} justify="end" wrap={false}>
                <Col>
                  <Button
                    size="small"
                    icon={<EditOutlined />}
                    onClick={() => {
                      state.openEditPartnerModal(partner.id);
                    }}
                  />
                </Col>
                <Col>
                  <Link to={`/handbook/sport-clubs?pid=${partner.id}`}>
                    <Button size="small">Clubs</Button>
                  </Link>
                </Col>
              </Row>
            );
          },
        },
      ]}
      pagination={false}
      size="small"
    />
  );
});
